import { Fragment } from 'react';
import GrievanceOfficerContact from '@/components/GrievanceOfficerContact';

/** Paste this token into CMS HTML to render the grievance officer card. */
export const GRIEVANCE_OFFICER_SHORTCODE = '[GrievanceOfficerContact]';

const SHORTCODE_PATTERN =
  /(?:<p\b[^>]*>\s*)?\[\s*GrievanceOfficerContact\s*\](?:\s*<br\s*\/?>)?(?:\s*<\/p>)?/gi;

export function hasGrievanceOfficerShortcode(html: string) {
  return /\[\s*GrievanceOfficerContact\s*\]/i.test(html || '');
}

export function splitContentByGrievanceShortcode(html: string) {
  return (html || '').split(new RegExp(SHORTCODE_PATTERN.source, 'gi'));
}

export default function ContentWithShortcodes({ html }: { html: string }) {
  const parts = splitContentByGrievanceShortcode(html);

  if (parts.length === 1) {
    return <div className="content-prose" dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return (
    <>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {part.trim() ? (
            <div className="content-prose" dangerouslySetInnerHTML={{ __html: part }} />
          ) : null}
          {index < parts.length - 1 ? <GrievanceOfficerContact /> : null}
        </Fragment>
      ))}
    </>
  );
}
